import { render, staticRenderFns } from "./OnlineBookingFeesList.vue?vue&type=template&id=077566c4"
import script from "./OnlineBookingFeesList.vue?vue&type=script&lang=js"
export * from "./OnlineBookingFeesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports